<template>
    <div class="setarea">
        <div class="setarea-a">
            <el-row :gutter="12">
                <el-col class="mudiaCol" >
                    <el-card shadow="hover"
                        style="height:220px;margin-bottom:5px; display: flex;align-items: center;justify-content: center;">
                         <el-table
    :data="tableData"
    style="width: 100%">
    <el-table-column
      label="日期"
      width="180">
      <template slot-scope="scope">
        <i class="el-icon-time"></i>
        <span style="margin-left: 10px">{{ scope.row.date }}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="姓名"
      width="180">
      <template slot-scope="scope">
        <el-popover trigger="hover" placement="top">
          <p>姓名: {{ scope.row.name }}</p>
          <p>住址: {{ scope.row.address }}</p>
          <div slot="reference" class="name-wrapper">
            <el-tag size="medium">{{ scope.row.name }}</el-tag>
          </div>
        </el-popover>
      </template>
    </el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button
          size="mini"
          @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        <el-button
          size="mini"
          type="danger"
          @click="handleDelete(scope.$index, scope.row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
                       
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row
                            style="height:180px;display: -webkit-flex;display:flex;flex-direction:row;justify-content:center;align-items:center;">
                            <span style="font-size:30px;color:orange;">
                                <el-button style="width:100px;" type="warning" size="medium"
                                    @click="goBack">返回</el-button>
                            </span>
                        </el-row>
                    </el-card>
                </el-col>
            </el-row>

        </div>
    </div>
</template>
<script>

import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
    data() {
        return {
            timeArr: [[]], // 二维数组存储每个时间选择器的值
        }
    },
    methods: {
        // 时间统一化
        timeChange(time) {

        },
        goBack() {
            bus.$emit('close_current_tags');
        },
        // 新增按钮方法（替换原handleEdit，语义更清晰）
        handleAdd(index) {
            this.timeArr.push([])
            console.log('新增时间项，索引：', index);
        },
        // 删除按钮方法（替换原handleEdit，语义更清晰）
        handleDelete(index) {
            if(this.timeArr.length<1){
                return ;
            }else{
                this.timeArr.splice(index,1);

            }
        }
    },
    created() {

    },

}
</script>
<style lang="scss" scoped>
.setarea {
    margin: 20px 5px;

    .setarea-a {
        padding: 5px;
        border: 1px solid rgb(243, 234, 234);
    }
}

// 时间选择器容器：占满卡片高度，实现上下左右居中
.time-picker-container {
    height: calc(100% - 60px); // 减去按钮区域高度，确保居中且不与按钮重叠
    display: flex;
    justify-content: center; // 水平居中
    align-items: center; // 垂直居中
}

// 按钮组容器：固定在卡片右下角
.button-group {
    position: absolute;
    bottom: 20px; // 与卡片底部保持距离（匹配el-card__body的padding）
    right: 20px; // 与卡片右侧保持距离
    display: flex; // 让按钮横向排列
    align-items: center;
}

@media screen and (min-width:1200px) {
    .el-dialog {
        width: 30% !important;
    }
}

@media screen and (min-width:600px) and (max-width:1199px) {
    .el-dialog {
        width: 60% !important;
    }
}

.el-table-qx {
    width: 80% !important;
    margin: 0 auto;
}

.is-center {
    height: 65px !important;

}

.el-card {
    transition: 1s;
    // border:1px solid rgb(218, 205, 205);
    box-shadow: 1px 2px 3px 4px #ccc inset;
    position: relative; // 为按钮组的绝对定位提供参考
}

.el-card:hover {
    //border:1px solid rgb(36, 34, 34) !important; 
    border: 1px solid rgb(218, 205, 205);
    cursor: pointer;
}

.el-date-editor {
    width: 200px;
}

//  深度作用选择符
.el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
}

.el-upload-list {
    float: right;
}

.el-dialog-map .el-dialog {
    width: 95% !important;
}

//地图插件·
.BMap_stdMpCtrl {
    top: 50px !important;
}

.citylist_popup_main {
    margin-left: 45px;
}

@media screen and (min-width: 1200px) {
    .safemap {
        border: 1px solid rgb(228, 222, 222);

        .map {
            width: 70%;
            height: 500px;
            float: left;
        }
    }
}

@media screen and (min-width: 600px) and (max-width:1199px) {
    .safemap {
        border: 1px solid rgb(228, 222, 222);

        .map {
            width: 55%;
            height: 500px;
            float: left;
        }
    }
}

@media screen and (min-width: 1200px) {
    .saferight {
        width: 30%;
        height: 500px;
        border: 1px solid #000;
        float: right;
        box-sizing: border-box;
    }
}

@media screen and (min-width:600px) and (max-width: 1199px) {
    .saferight {
        width: 45%;
        height: 500px;
        border: 1px solid #000;
        float: right;
        box-sizing: border-box;
    }
}

//安全区域设置详情
@media screen and (min-width:1200px) {
    .SafeDetail .el-dialog {
        margin-top: 80px !important;
        width: 90% !important;
    }
}

@media screen and (min-width:600px) and (max-width:1199px) {
    .SafeDetail .el-dialog {
        top: 20px !important;
        width: 80% !important;
    }
}

@media screen and (min-width:1200px) and (max-width:1500px) {
    .remind .el-dialog {
        width: 40% !important;
    }
}

.clockfile {
    border: 1px solid rgb(240, 232, 232);
}

//白名单dialog
.whitephonelist .el-dialog__body {
    height: 400px !important;
    overflow-y: scroll !important;
}

.el-card__body {
    padding: 20px !important;
}

.class-error {
    color: red;
}

.class-ok {
    color: green;
}

/*适配不同的屏幕*/
@media screen and (min-width:1000px) and (max-width:1530px) {
    .mudiaCol {
        width: 50% !important;
    }
}

@media screen and (min-width:1531px) and (max-width:1920px) {
    .mudiaCol {
        width: 33.333% !important;
    }
}

@media screen and (min-width:1921px) {
    .mudiaCol {
        width: 33.333% !important;
    }
}

@media screen and (min-width:1000px) and (max-width:1530px) {
    .formName .el-input__inner {
        width: 140px !important;
    }
}

@media screen and (min-width:1531px) and (max-width:1920px) {
    .formName .el-input__inner {
        width: 180px !important;
    }
}

@media screen and (min-width:1921px) {
    .formName .el-input__inner {
        width: 180px !important;
    }
}
</style>